exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".photo-page-templates {\n  background-size: contain;\n  width: 204px;\n  height: 265px;\n  border-radius: 5px;\n  box-shadow: 0px 0px 10px 0px silver;\n}\n.photo-page-templates:hover {\n  box-shadow: 0px 0px 10px 0px #01b1af;\n  cursor: pointer;\n}\n", ""]);

// exports
